import { Base2Presenter } from "core/presenter";
import { CategoryRepository } from "core/repository";

export default class ProductListFilterPresenter extends Base2Presenter {
  initialState() {
    return {
      categorySearchOptions: {
        online: true,
        repository: CategoryRepository,
        order: [{ field: "name", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: filter => this.getFilter(filter)
      }
    };
  }

  getFilter(value) {
    return [
      { field: "name", operation: "LIKE", value },
      { field: "deleted", operation: "EQ", value: false }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/filter/presenter.js